// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2Vqed","file":"styles_file__3mxaD"};